import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Users = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M6.421 16.496C6.15 15.635 6 14.773 6 14C6 10.692 8.692 8 12 8C13.069 8 14.073 8.283 14.944 8.775C16.011 7.108 17.878 6 20 6C23.308 6 26 8.692 26 12C26 12.773 25.85 13.635 25.579 14.496C28.166 15.525 30 18.051 30 21C30 22.654 28.654 24 27 24H21.828C21.415 25.164 20.304 26 19 26H5C3.346 26 2 24.654 2 23C2 20.051 3.834 17.525 6.421 16.496V16.496ZM8 14C8 16.479 10.069 20 12 20C13.931 20 16 16.479 16 14C16 11.794 14.206 10 12 10C9.794 10 8 11.794 8 14ZM20 8C18.502 8 17.195 8.828 16.51 10.05C17.436 11.106 18 12.488 18 14C18 14.773 17.85 15.635 17.579 16.496C18.45 16.842 19.236 17.357 19.894 18.002C19.928 18.001 19.963 18 20 18C21.931 18 24 14.479 24 12C24 9.794 22.206 8 20 8ZM28 21C28 18.88 26.673 17.066 24.806 16.34C24.672 16.593 24.529 16.84 24.376 17.077C23.473 18.479 22.381 19.408 21.22 19.794C21.571 20.472 21.815 21.216 21.927 22H27C27.551 22 28 21.551 28 21V21ZM5 24H19C19.551 24 20 23.551 20 23C20 20.88 18.673 19.066 16.806 18.34C16.672 18.593 16.529 18.84 16.376 19.077C15.162 20.962 13.608 22 12 22C10.392 22 8.838 20.962 7.624 19.077C7.471 18.84 7.328 18.592 7.194 18.34C5.327 19.066 4 20.88 4 23C4 23.551 4.449 24 5 24Z" />
	</svg>
);

export default Users;
